import { useMemo } from "react";
import { useGetVariantForFeatureQuery } from "redux/reduxAPI";
import {
  CAMPAIGN_THEME_FEATURE,
  getActiveCampaignTheme,
  isCampaignDisabledByFlag,
} from "utils/campaignTheme";

/**
 * The campaign theme active right now, or null. The theme applies straight
 * away and is withdrawn if the feature flag kill switch comes back DISABLED.
 * The flag is only fetched while a campaign is active.
 */
export const useCampaignTheme = () => {
  const activeCampaign = useMemo(() => getActiveCampaignTheme(), []);
  const { data: flagVariant } = useGetVariantForFeatureQuery(
    { feature_name: CAMPAIGN_THEME_FEATURE },
    { skip: !activeCampaign }
  );

  return isCampaignDisabledByFlag(flagVariant?.variant_name)
    ? null
    : activeCampaign;
};
